import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceModel } from "@app/models/rest/resource";

@Injectable({
  providedIn: "root"
})
export class ResourceRestService extends HateoasResourceOperation<ResourceModel> {
  constructor() {
    super(ResourceModel);
  }
}
